import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items, light = false }) {
  return (
    <nav aria-label="Breadcrumb" className="text-xs font-semibold" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={12} className={light ? "text-white/40" : "text-slate-400"} />}
            {it.to ? (
              <Link to={it.to} className={light ? "text-white/70 hover:text-gold" : "text-slate-500 hover:text-royal"}>
                {it.label}
              </Link>
            ) : (
              <span className={light ? "text-gold" : "text-royal"} aria-current="page">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
